const React = require('react');
const UseFormContextUtils = require('./context');
const { useFormState, useWatch } = require('react-hook-form');

const {
    createContext,
    useContext,
    useEffect,
    useMemo
} = React;

const FieldContext = createContext(null);

exports.FieldContext = FieldContext;

exports.FieldProvider = function FieldProvider(props) {

    const {
        actions,
        children,
        formConfig,
        formMethods,
        formModel,
        inputRefs,
        preferencesHandle
    } = props;

    const value = useMemo(
        () => UseFormContextUtils.buildFieldContextValue({
            actions,
            formConfig,
            formMethods,
            formModel,
            inputRefs,
            preferencesHandle
        }),
        [
            actions,
            formConfig,
            formMethods,
            formModel,
            inputRefs,
            preferencesHandle
        ]
    );

    return <FieldContext.Provider value={value}>
        {children}
    </FieldContext.Provider>;
};

exports.useFieldContext = () => {

    return useContext(FieldContext);
};

exports.useField = (fieldName) => {

    const contextValue = exports.useFieldContext();
    const control = contextValue?.formMethods?.control;
    const getDefaultFieldDefinition = contextValue?.formConfig?.getFieldDefinition
        || ((name) => ({
            name,
            label: name,
            type: 'TextField'
        }));
    const definition = getDefaultFieldDefinition(fieldName);
    const watchedValue = useWatch({
        control,
        name: fieldName
    });
    const formState = useFormState({
        control
    });
    const manualFieldErrorsVersion = contextValue?.formMethods?.__manualFieldErrorsVersion;
    const fieldError = UseFormContextUtils.getPath(contextValue?.formMethods?.__manualFieldErrors, fieldName)
        || UseFormContextUtils.getPath(formState.errors, fieldName)
        || contextValue?.formMethods?.getFieldState?.(
            fieldName,
            formState
        )?.error;

    useEffect(() => {

        if (!fieldName || typeof contextValue?.formMethods?.register !== 'function') {
            return;
        }

        contextValue.formMethods.register(
            fieldName,
            UseFormContextUtils.buildFieldRules(definition)
        );
    }, [contextValue?.formMethods, definition, fieldName]);

    return useMemo(
        () => UseFormContextUtils.buildFieldController({
            contextValue,
            fieldName,
            getDefaultFieldDefinition,
            defaultDefinition: definition,
            watchedValue,
            fieldState: {
                error: fieldError,
                errors: formState.errors
            }
        }),
        [contextValue, definition, fieldError, formState.errors, fieldName, getDefaultFieldDefinition, manualFieldErrorsVersion, watchedValue]
    );
};

exports.usePreferencesHandle = () => {

    return exports.useFieldContext()?.preferencesHandle;
};
